import type { PdfSearchCoverageBadgeState } from './pdf-search-coverage-badge';

export interface PdfCoverageResponse {
  textIndexed?: boolean;
  textIndexingAllowed?: boolean;
  textIndexingBlockedReason?: string | null;
  status?: string;
  candidatePageCount?: number;
  processedPageCount?: number;
  skippedPageCount?: number;
  failedPageCount?: number;
  managedCreditsAvailable?: boolean;
}

export function mapCoverageStatus(
  coverage: PdfCoverageResponse
): PdfSearchCoverageBadgeState['imageTextStatus'] {
  if (coverage.status === 'pending') return 'pending';
  if (coverage.status === 'complete') return 'complete';
  if (coverage.status === 'failed') return 'failed';
  if (coverage.status === 'partial') return 'partial';
  if ((coverage.candidatePageCount ?? 0) > 0) return 'manual';
  return 'complete';
}

export function shouldOpenPdfSearchCoverageCoachmark(
  state: PdfSearchCoverageBadgeState,
  candidatePageCount: number
): boolean {
  return (
    state.availability === 'available' &&
    state.textIndexed &&
    candidatePageCount > 0 &&
    (state.imageTextStatus === 'manual' ||
      state.imageTextStatus === 'partial' ||
      state.imageTextStatus === 'failed')
  );
}

export function requiresPdfOcrConfirmation(
  candidatePageCount: number,
  thresholdPages: number
): boolean {
  return candidatePageCount > thresholdPages;
}
